const confirmationModalStyles = {
	body: 'p-0',
	bodyText: 'text-sm text-[#2e2e3a] leading-[1.4] font-[Figtree,sans-serif]',
	footer: 'border-t-0 px-0 py-0',
	stack: 'flex flex-col gap-6 px-6 pb-6 max-[540px]:gap-5 max-[540px]:px-5 max-[540px]:pb-5',
	actionsRow: 'flex items-center justify-end gap-2 w-full'
} as const;

export { confirmationModalStyles };
